export const platformSettingsPublicSelector = (state) => state.platformSettings.public;
export const platformSettingsAdminSelector = (state) => state.platformSettings.admin;
export const platformSettingsFetchPublicStatusSelector = (state) => state.platformSettings.fetchPublicStatus;
export const platformSettingsFetchAdminStatusSelector = (state) => state.platformSettings.fetchAdminStatus;
export const platformSettingsUpdateStatusSelector = (state) => state.platformSettings.updateStatus;
